import React from 'react';
import PropTypes from 'prop-types';

const CellGenericString = ({ data, isExpired }) => {

    return (
        <td
            colSpan="1"
            className={ isExpired && "c-row-expired"}
            role="gridcell"
            aria-colindex="1"
            aria-selected="false"
            data-grid-col-index="0"
        >
            { data }
        </td>
    )
}

CellGenericString.propTypes = {
    data: PropTypes.string,
    isExpired: PropTypes.bool,
}

export default CellGenericString;